// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"112ae08e","483":"e680a167"}[chunkId] + ".chunk.css";
};